module.exports = __webpack_public_path__ + "static/img/2.c20ec72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/2.png
// module id = 20Qs
// module chunks = 0